import {
  DoctorDetailsActionTypes,
  DOCTOR_DETAILS_FAIL,
  DOCTOR_DETAILS_LOADING,
  DOCTOR_DETAILS_SUCCESS,
  DoctorDetailsState,
  DOCTOR_DETAILS_API_MSG,
  DOCTOR_DETAILS_API_RES,
} from "./ActionTypes";
import { DoctorDetailsResponse } from "./Model";

const initialStateEditPosts: DoctorDetailsState = {
  loading: false,
  doctorDetailsResponse: {} as DoctorDetailsResponse,
  successMsg: "",
  errorMsg: "",
  status: 0,
};
export const doctorDetailsReducer = (
  state = initialStateEditPosts,
  action: DoctorDetailsActionTypes
): DoctorDetailsState => {
  switch (action.type) {
    case DOCTOR_DETAILS_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case DOCTOR_DETAILS_SUCCESS:
      return {
        ...state,
        doctorDetailsResponse: action.payload,
        successMsg: action.successMsg,
      };
    case DOCTOR_DETAILS_FAIL:
      return {
        ...state,
        doctorDetailsResponse: action.payload,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case DOCTOR_DETAILS_API_MSG:
      return {
        ...state,
        doctorDetailsResponse: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case DOCTOR_DETAILS_API_RES:
      return {
        ...state,
        doctorDetailsResponse: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    default:
      return state;
  }
};
